/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ store: NonNullable<unknown> }} Plan_Cancel_From_StoreInputs */

const en_plan_cancel_from_store = /** @type {(inputs: Plan_Cancel_From_StoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`To cancel your subscription, manage it from the ${i?.store}.`)
};

const es_plan_cancel_from_store = /** @type {(inputs: Plan_Cancel_From_StoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Para cancelar tu suscripción, adminístrala desde ${i?.store}.`)
};

/**
* | output |
* | --- |
* | "To cancel your subscription, manage it from the {store}." |
*
* @param {Plan_Cancel_From_StoreInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_cancel_from_store = /** @type {((inputs: Plan_Cancel_From_StoreInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Cancel_From_StoreInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_cancel_from_store(inputs)
	return en_plan_cancel_from_store(inputs)
});